export const LOGO_MAX_SIZE_MB = 5
export const LOGO_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif']
export const HERO_MAX_SIZE_MB = 50
export const HERO_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif', 'video/mp4', 'video/webm']
export const HERO_VIDEO_THUMBNAIL_MAX_SIZE_MB = 10
export const HERO_VIDEO_THUMBNAIL_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp']
